exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_permissionsEditPanel_1FPeYrKDKyz3NAtzUS_gNx {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_content_3yEAy-QMWcBdNKQwBiyC3u {\n  position: relative;\n  float: left;\n  width: calc(100% - 40px);\n  height: 100%;\n  padding-left: 40px;\n  box-sizing: border-box;\n}\n\n.IA_permissionsSearchResult_16xjooJAZ5xW2CFVfmjB97 {\n  margin-top: 100px;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_permissionsEditPanel": "IA_permissionsEditPanel_1FPeYrKDKyz3NAtzUS_gNx",
	"IA_content": "IA_content_3yEAy-QMWcBdNKQwBiyC3u",
	"IA_permissionsSearchResult": "IA_permissionsSearchResult_16xjooJAZ5xW2CFVfmjB97"
};